
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <h5><b>Genre: {{ this.$route.query.name }}</b></h5>
      <div v-for="data in movies" :key="data.id" class="col-md-2 col-6">
        <div class="card">
          <div class="card-body">
            <div class="product-img position-relative">
              <div class="product-ribbon">
                <span class="bg-dark text-white p-2 rounded-2 small">{{ data.rating }}</span>
              </div>
              <router-link :to="{ path: '/movie', query: { id: data.movie_id }}">
                <img :src="getFiles(data.photo)" class="img-fluid mx-auto d-block"/>
              </router-link>
            </div>
              <h5 class="mt-2">
                <router-link tag="a" class="text-dark" :to="{ path: '/movie', query: { id: data.movie_id }}"> <b>{{ data.name }}</b> <small> ({{ (data.year) }})</small></router-link>
              </h5>
              <h5><small> <i class="mdi mdi-calendar"></i> {{new Date(data.releasedate).toLocaleDateString('en-US', options)}} </small></h5>
          </div>
        </div>
      </div>
      <div v-if="movies.length<=0" class="text-center p-4">
          <i class="fas fa-video fa-4x"></i> <br>
          No Movies Found<br><br>
          <router-link tag="a" to="/movies" class="btn btn-sm btn-success" >View Movies</router-link>
      </div>
    </div>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { movieMethods, movieComputed } from "@/state/helpers";

export default {
  page: {
    title: "Movies by Genre",
    meta: [{name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Movies by Genre",
      items: [
        {text: "Movies",href: "/",},
        {text: "Genre",active: true, },
      ],
      options : { year: "numeric", month: "short", day: "numeric",},
    };
  },
  mounted() {
    this.FindByGenre(this.$route.query.id);
  },
  computed: {
    ...movieComputed,
  },
  methods: {
    ...movieMethods,
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"movies/"+name;
      return imagelink;
    },
    FindByGenre(genre){
      this.filterMoviesByGenre({genre:genre});
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>